query GetIntegrationListCount(
  $integrationId: ID!,
  $listIds: [String],
  $listType: ListType!,
) {
  getIntegrationListCount(
    integrationId: $integrationId,
    listIds: $listIds,
    listType: $listType,
  ) {
    membersCounter {
      listIds
      total
    }
  }
}
